import type { IconButtonProps } from '@mui/material/IconButton';

import { useState, useCallback, useEffect } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Popover from '@mui/material/Popover';
import Divider from '@mui/material/Divider';
import MenuList from '@mui/material/MenuList';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuItem, { menuItemClasses } from '@mui/material/MenuItem';
import AWS from 'aws-sdk';
import { useRouter, usePathname } from 'src/routes/hooks';

import { _myAccount } from 'src/_mock';
import { fetchData } from 'src/utils/adminAPI';

// ----------------------------------------------------------------------

export type AccountPopoverProps = IconButtonProps & {
  data?: {
    label: string;
    href: string;
    icon?: React.ReactNode;
    info?: React.ReactNode;
  }[];
};
const s3 = new AWS.S3({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID || 'AKIA2OL3IQKYE436PFKM',
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY || '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',
  region: process.env.REACT_APP_AWS_REGION || 'ap-southeast-1',
});
export function AccountPopover({ data = [], sx, ...other }: AccountPopoverProps) {
  const router = useRouter();
  const res = JSON.parse(localStorage.getItem('info_user') || '{}');
  const pathname = usePathname();
  
  const [openPopover, setOpenPopover] = useState<HTMLButtonElement | null>(null);
  const [id, setId] = useState<string | null>('');
  const [name, setName] = useState<string | null>('');
  const [companyName, setCompanyName] = useState<string | null>('');
  const [url, setUrl] = useState<string | null>(null);

  const handleOpenPopover = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenPopover(event.currentTarget);
  }, []);

  const handleClosePopover = useCallback(() => {
    setOpenPopover(null);
  }, []);

  const handleClickItem = useCallback(
    (path: string) => {
      handleClosePopover();
      router.push(path);
    },
    [handleClosePopover, router]
  );

  useEffect(() => {
    const getInfo = async () => {
      const companyUserResponse = await fetchData<any>('/auth/company-users');
      if (companyUserResponse.statusCode !== 200) {
        return;
      }
      console.log(companyUserResponse);
      

      type CompanyUser = {
        userId: string;
        companyId: string;
      };

      // Cast data to an array of CompanyUser
      const companyUsers: CompanyUser[] = companyUserResponse.data;

      const userCompany = companyUsers.find((cu) => cu.userId === res?.id);
      if (!userCompany) {
        return; // Exit early if userCompany is undefined
      }

      console.log(userCompany);
      setId(userCompany.companyId);
      const response = await fetchData<any>(`company/company/${userCompany.companyId}`);
      
      setId(userCompany.companyId);
      setCompanyName(response.data.vnName);

      const userResponse = await fetchData<any>(`auth/user/${res?.id}`);
      setName(userResponse.data.name);
      // setUrl(`${import.meta.env.VITE_BASE_URL}${userResponse.data.avartar.slice(1)}`);
      const imageUrl = await s3.getSignedUrlPromise('getObject', {
        Bucket: 'vngic-stogare',
        Key: userResponse.data.avartar,
      });
      
      setUrl(imageUrl)
    }

    getInfo();
  }, [res?.id, res?.avartar]);

  return (
    <>
      <IconButton
        onClick={handleOpenPopover}
        sx={{
          p: '2px',
          width: 40,
          height: 40,
          background: (theme) =>
            `conic-gradient(${theme.vars.palette.primary.light}, ${theme.vars.palette.warning.light}, ${theme.vars.palette.primary.light})`,
          ...sx,
        }}
        {...other}
      >
        <Avatar src={url ?? undefined} alt={name ?? undefined} sx={{ width: 1, height: 1 }}>
          {name?.slice(0, 1).toUpperCase()}
        </Avatar>
      </IconButton>

      <Popover
        open={!!openPopover}
        anchorEl={openPopover}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: { width: 200 },
          },
        }}
      >
        <Box sx={{ p: 2, pb: 1.5 }}>
          <Typography variant="subtitle2" noWrap>
            {res?.name}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {res?.userName}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuList
          disablePadding
          sx={{
            p: 1,
            gap: 0.5,
            display: 'flex',
            flexDirection: 'column',
            [`& .${menuItemClasses.root}`]: {
              px: 1,
              gap: 2,
              borderRadius: 0.75,
              color: 'text.secondary',
              '&:hover': { color: 'text.primary' },
              [`&.${menuItemClasses.selected}`]: {
                color: 'text.primary',
                bgcolor: 'action.selected',
                fontWeight: 'fontWeightSemiBold',
              },
            },
          }}
        >
          {data.map((option) => (
            <MenuItem
              key={option.label}
              selected={option.href === pathname}
              onClick={() => handleClickItem(option.href)}
            >
              {option.icon}
              {option.label}
            </MenuItem>
          ))}
        </MenuList>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Box sx={{ p: 1 }}>
          <Button fullWidth color="error" size="medium" variant="text" onClick={() => {
              localStorage.removeItem('info_user');
              localStorage.removeItem("token");
              router.push('/sign-in');
            }}>
            Logout
          </Button>
        </Box>
      </Popover>
    </>
  );
}
